enum Routes {
    INDEX = "/",
    LOGIN = "/login",
    LOGOUT = "/logout"
}

export default Routes;